module.exports = __webpack_public_path__ + "img/2.7f8481ad.png";